var localeValues = {
  Table: {
    emptyText: 'No data'
  },
  Pagination: {
    goToPage: 'Go to page',
    go: 'Go',
    page: 'Page',
    sizeWithTotal: '{start} - {end} of {total} items'
  },
  DatePicker: {
    locale: 'en',
    placeholder: 'Select Date',
    yearFormat: 'YYYY',
    confirm: 'Confirm',
    monthBeforeYear: true
  },
  Modal: {
    title: 'Alarm',
    confirmText: 'Confirm',
    cancelText: 'Cancel'
  },
  Cascader: {
    placeholder: 'Select'
  },
  TimePicker: {
    placeholder: 'Select Time'
  },
  Transfer: {
    filterPlaceholder: 'Search',
    searchEmptyPlaceholder: 'Your search does not match any results'
  },
  Upload: {
    filename: 'file'
  },
  Select: {
    noMatchText: 'No result',
    searchHintText: 'Input Search Query'
  }
};
export default localeValues;